
import React from "react";
import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

type BaseAssignment = {
  id: string;
  role: string;
  base_name: string;
};

interface AssignedBasesListProps {
  loading: boolean;
  assignedBases: BaseAssignment[];
  onRemoveBase: (id: string) => void;
}

export const AssignedBasesList = ({
  loading,
  assignedBases,
  onRemoveBase
}: AssignedBasesListProps) => {
  if (loading) {
    return (
      <div className="flex justify-center p-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  
  if (assignedBases.length === 0) {
    return (
      <p className="text-muted-foreground">No bases assigned to this role yet.</p>
    );
  }
  
  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium">Assigned Bases:</h3>
      <div className="flex flex-wrap gap-2">
        {assignedBases.map((assignment) => (
          <Badge 
            key={assignment.id} 
            variant="secondary"
            className="flex items-center gap-1"
          >
            {assignment.base_name}
            <button 
              className="ml-1 h-4 w-4 rounded-full bg-gray-400/30 text-gray-500 hover:bg-gray-400/50 flex items-center justify-center text-xs"
              onClick={() => onRemoveBase(assignment.id)}
            >
              ×
            </button>
          </Badge>
        ))}
      </div>
    </div>
  );
};
